@if (totalPages() > 0) {
  <nav class="pagination-container" [class.disabled]="disabled()">
    <div class="pagination-controls">
      @if (showFirstLast()) {
        <button
          class="pagination-btn first"
          [disabled]="isFirstPage() || disabled()"
          (click)="goToFirst()"
          aria-label="First page"
        >
          <span class="first-last-bar">|</span>
          <span>‹</span>
        </button>
      }

      @if (showPrevNext()) {
        <button
          class="pagination-btn prev"
          [disabled]="isFirstPage() || disabled()"
          (click)="goToPrevious()"
          aria-label="Previous page"
        >
          ‹
        </button>
      }

      @for (pageNum of visiblePages(); track pageNum) {
        <button
          class="pagination-btn page-number"
          [class.active]="pageNum === page"
          [disabled]="disabled()"
          (click)="goToPage(pageNum)"
          [attr.aria-label]="'Go to page ' + pageNum"
          [attr.aria-current]="pageNum === page ? 'page' : null"
        >
          {{ pageNum }}
        </button>
      }

      @if (showPrevNext()) {
        <button
          class="pagination-btn next"
          [disabled]="isLastPage() || disabled()"
          (click)="goToNext()"
          aria-label="Next page"
        >
          ›
        </button>
      }

      @if (showFirstLast()) {
        <button
          class="pagination-btn last"
          [disabled]="isLastPage() || disabled()"
          (click)="goToLast()"
          aria-label="Last page"
        >
          <span>›</span>
          <span class="first-last-bar">|</span>
        </button>
      }

      <div class="page-input-container">
        <input
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          class="page-input"
          [value]="pageInputValue() ?? ''"
          [min]="1"
          [max]="totalPages()"
          [disabled]="disabled()"
          (input)="onPageInputChange($event)"
          (keydown)="onPageInputKeydown($event)"
          (blur)="navigateToInputPage()"
          aria-label="Go to page"
        />
        <span class="page-total-text">of {{ totalPages() }} pages</span>
      </div>
    </div>
  </nav>
}

